import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import styles from "./RecruitmentNoticeModal.module.scss";

const REDIRECT_SECONDS = 10;

const RecruitmentNoticeModal = () => {
  const [secondsLeft, setSecondsLeft] = useState(REDIRECT_SECONDS);
  const history = useHistory();

  useEffect(() => {
    if (secondsLeft <= 0) {
      history.push("/");
      return;
    }

    const timerId = setTimeout(() => setSecondsLeft((s) => s - 1), 1000);
    return () => clearTimeout(timerId);
  }, [secondsLeft, history]);

  const redirectNow = () => history.push("/");

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <h2 className={styles.title}>Recruitment Disclaimer</h2>
        <p className={styles.message}>
          Please verify all job opportunities directly through our official
          Careers Page. Any vacancy shared by an unauthorised third party
          that is not listed here should not be considered an official
          opening from Mindfire Digital LLP.
        </p>
        <p className={styles.message}>
          Mindfire does not charge any fee at any stage of the recruitment
          process and is not responsible for false or misleading job
          postings published by unauthorised individuals or third-party
          pages.
        </p>
        <p className={`${styles.message} ${styles.countdown}`}>
          You will be redirected to our official Careers Page automatically
          in a few seconds or{" "}
          <span
            className={styles.link}
            role="button"
            tabIndex={0}
            onClick={redirectNow}
            onKeyDown={(event) => {
              if (event.key === "Enter" || event.key === " ") {
                redirectNow();
              }
            }}
          >
            click here
          </span>
          .
        </p>
      </div>
    </div>
  );
};

export { RecruitmentNoticeModal };
